const prepareOrders = (
  orderTypeContext,
  ordersContext,
  orderTotal,
  tableNumber,
  orderMessage
) => {
  const hotelIDValue = localStorage.getItem("hotelID");
  const dateValue = new Date();
  const dateString = dateValue.toDateString();
  var tempOrder = {
    metadata: orderTypeContext,
    hotelID: hotelIDValue,
    order: { ...ordersContext },
    orderTotal: orderTotal,
    status: "Order Placed",
    message: orderMessage,
    date: dateString,
  };

  if (orderTypeContext === "tableside") {
    const tableNumberName = "tableNumber";
    tempOrder = { ...tempOrder, [tableNumberName]: tableNumber };
  }
  return tempOrder;
};
export const sendToKitchenCustomer = async (
  ordersContext,
  orderTypeContext,
  orderTotal,
  tableNumber,
  orderMessage,
  customerEmail,
  setOrderStatus,
  setOrderID,
  loaderClassFunction
) => {
  var tempOrder = prepareOrders(
    orderTypeContext,
    ordersContext,
    orderTotal,
    tableNumber,
    orderMessage
  );
  tempOrder = { ...tempOrder, customerEmail: customerEmail };
  loaderClassFunction("loader-class-visible");
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/order/addOrder",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(tempOrder),
      }
    );
    const result = await response.json();
    const { status, _id } = result;
    setOrderStatus(status);
    setOrderID(_id);
    localStorage.setItem("orderID", _id);
  } catch (error) {
    console.log(error.message);
  }
  loaderClassFunction("loader-class-hidden");
};
export const sendToKitchen = async (
  ordersContext,
  orderTypeContext,
  orderTotal,
  tableNumber,
  orderMessage
) => {
  var tempOrder = prepareOrders(
    orderTypeContext,
    ordersContext,
    orderTotal,
    tableNumber,
    orderMessage
  );
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/order/addOrder",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(tempOrder),
      }
    );
    const result = await response.json();
    console.log(result);
  } catch (error) {
    console.log(error.message);
  }
};
export const getOrderStatus = async (orderID, setOrderStatus) => {
  const requestObject = {
    ID: orderID,
  };
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/order/getOrderStatus",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
    const { status } = result;
    if (status !== "Order Placed" || status !== "Preparing") {
      localStorage.removeItem("orderID");
    }
    setOrderStatus(status);
  } catch (error) {
    console.log(error.message);
  }
  setTimeout(() => {
    console.log("something");
    getOrderStatus(orderID, setOrderStatus);
  }, 10000);
};
export const sortOrders = (
  ordersContext,
  setPlacedOrders,
  setPreparingOrders,
  setDoneOrders
) => {
  var tempPlacedOrders = {};
  var tempPreparingOrders = {};
  var tempDoneOrders = {};
  Object.keys(ordersContext).map((index) => {
    const tempOrder = ordersContext[index];
    if (tempOrder["status"] === "Preparing") {
      tempPreparingOrders = { ...tempPreparingOrders, [index]: tempOrder };
    } else if (tempOrder["status"] === "Order Placed") {
      tempPlacedOrders = { ...tempPlacedOrders, [index]: tempOrder };
    } else {
      tempDoneOrders = { ...tempDoneOrders, [index]: tempOrder };
    }
    return 0;
  });
  setPlacedOrders(tempPlacedOrders);
  setDoneOrders(tempDoneOrders);
  setPreparingOrders(tempPreparingOrders);
};

export const updateOrderItems = (preparingOrders, setFunction) => {
  var newObject = {};
  Object.keys(preparingOrders).map((index) => {
    const tempOrder = preparingOrders[index];
    const tempOrderDetails = tempOrder["order"];
    Object.keys(tempOrderDetails).map((i) => {
      const orderItem = tempOrderDetails[i];
      var count;
      if (newObject[i]) {
        count = orderItem["itemCount"] + newObject[i];
        newObject = { ...newObject, [i]: count };
      } else {
        count = orderItem["itemCount"];
        newObject = { ...newObject, [i]: count };
      }
      return 0;
    });
    return 0;
  });
  setFunction(newObject);
};

export const orderProcessing = (
  ordersContext,
  setTotalRevenue,
  setTableSideOrders,
  setTakeawayOrders
) => {
  var tempTableside = {};
  var tempTakeaway = {};
  var tempTotal = 0;
  Object.keys(ordersContext).map((index) => {
    const tempObject = ordersContext[index];
    if (tempObject["metadata"] === "takeaway") {
      tempTakeaway = { ...tempTakeaway, [index]: tempObject };
    } else if (tempObject["metadata"] === "tableside") {
      tempTableside = { ...tempTableside, [index]: tempObject };
    }
    tempTotal = tempTotal + tempObject["orderTotal"];
    return 0;
  });
  setTotalRevenue(tempTotal);
  setTableSideOrders(tempTableside);
  setTakeawayOrders(tempTakeaway);
};

export const updateOrderStatus = async (ID, status) => {
  const requestObject = {
    ID: ID,
    status: status,
  };
  var userToken;
  if (localStorage.getItem("user")) {
    userToken = localStorage.getItem("user");
  } else if (localStorage.getItem("affiliate")) {
    userToken = localStorage.getItem("affiliate");
  }
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/order/updatestatus",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          "auth-token": userToken,
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
  } catch (error) {
    console.log(error.message);
  }
};

export const getOrder = async (
  orderID,
  setCustomerOrder,
  setOrderMessage,
  setTableNumber,
  setCustomerEmail,
  setOrderStatus
) => {
  const requestObject = {
    ID: orderID,
  };
  try {
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/order/getOrderStatus",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
    const { status, order, tableNumber, message, customerEmail } = result;
    if (status === "Order Placed" || status === "Preparing") {
      setOrderStatus(status);
      setCustomerOrder(order);
      setTableNumber(tableNumber);
      setCustomerEmail(customerEmail);
      setOrderMessage(message);
    }
  } catch (error) {
    console.log(error.message);
  }
};
